import { TransportMode} from '../../../../requestList/models/transportMode';
import { ITransportModeService } from '../../../../requestList/services/transportModeService';
import { RequestDetailEdit } from '../../../../requestDetailEdit/models/requestDetailEdit';

export class AddShippingDetailsController implements ng.IController {

    private _transportModes: TransportMode[];
    requestDetailEdit: RequestDetailEdit;
    static $inject = ['transportModeService'];
    selectedTransportMode: TransportMode;
    _isLoading: boolean;
    isConsigneeSearchLoading: boolean;
    isConsigneeSearchValid: boolean;
    mindate: Date;
    chargesToForm: ng.IFormController;
    contactForm: ng.IFormController;
    assetForm: ng.IFormController;

    constructor(private _transportModeService: ITransportModeService) {
    }

    $onInit() {
        this._isLoading = true;
        this._transportModeService.getTransportModes().then(o => this.handleGetTransportModes(o));
        this.mindate = new Date();
        this.mindate.setDate(this.mindate.getDate() + 1);
        if (this.shipmentNotUndefined()) {
            var requestedDeliveryDate = this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate;
            if (requestedDeliveryDate !== undefined && requestedDeliveryDate.toString().length < 12) {
                this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate = new Date(requestedDeliveryDate.toString() + "T00:00");
            }
        }
    }

    setMaxShipReadyDate() {
       
        if (this.shipmentNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate !== undefined) {
            this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate = angular.copy(this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate);
            this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate.setDate(this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate.getDate() - 1);
       
        }

    }

   
    get isLoading(): boolean {
      return this._isLoading || this.isConsigneeSearchLoading;
    }

    set isLoading(val : boolean) {}

    isChargeToConsigneeEnabled(val: string): boolean {
      return (val === "Yes");
    }

    onChargetoConsigneeChange() {
        if (this.shipmentNotUndefined() &&  
            this.requestDetailEdit.requestDetail.requestShipment.additionalFreightCharges !== undefined) {
            this.requestDetailEdit.requestDetail.requestShipment.additionalFreightCharges = undefined;
            this.requestDetailEdit.requestDetail.requestShipment.additionalPackagingFees = undefined;
        }
    }
    isFAMREnabled(val: string): boolean {
        return (val === "Yes");
    }
  
    private handleGetTransportModes(options: TransportMode[]) {
        this._transportModes = options;
        this._isLoading = false;
    }

    get transportModes(): TransportMode[] {
        return this._transportModes;
    }
    
    //contactForm
    get isValid(): boolean {
        return this.isConsigneeSearchValid && (this.chargesToForm ? this.chargesToForm.$valid : false) && (this.contactForm ? this.contactForm.$valid : false) && 
            (this.assetForm ? this.assetForm.$valid : false) &&  this.isTransportModeLtlValid;
    }

    set isValid(isValid: boolean) {

    }


    get onClickCheck(): boolean {
        if (this.requestDetailEdit.requestDetail.requestShipment.isAssetValue === 'Yes' &&
            this.requestDetailEdit.requestDetail.requestShipment.isFAMRValue === 'No') {
            return false;
        }
        return true;
    }

    set onClickCheck(onClickCheck: boolean) {

    }

    get onClickMessage(): string {
        return 'You should have completed FAMR if the material is an asset';
    }

    set onClickMessage(onClickMessage: string) {

    }

    get isTransportModeLtlValid()  : boolean {
        
        if (this.shipmentNotUndefined() && this.consigneeNotUndefined() &&
                this.requestDetailEdit.requestDetail.requestShipment.transportMode !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee.countryCode !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.transportMode.toUpperCase() === "LTL") {

            var countryCode = this.requestDetailEdit.requestDetail.requestConsignee.countryCode.toUpperCase();

            if (countryCode === "US" ||
                countryCode === "CA" ||
                countryCode === "PR") {
                return true;
            } else {
                return false;
            }
        }
        
        return true;
    }

    isAssetOnChange(): void {
        if (this.requestDetailEdit.requestDetail.requestShipment.isAssetValue === "No") {
            this.requestDetailEdit.requestDetail.requestShipment.isFAMRValue = "No";
        }
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined;
    }

    getPopupText(transportationMode): string {
        if (transportationMode === 'Air')
            return 'This option is for shipments that can’t be shipped through the mail center and aren’t large enough or are too time sensitive for Ocean -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Express')
            return 'This option is for documents or small packages that can be shipped via Express like FedEx, UPS, or DHL -Mail Center will manage most of these requests';
        else if (transportationMode === 'LTL')
            return 'This option is for palletized shipments that are less than 10,000kg for USA to USA, USA to Canada, or USA to Mexico with a standard trucking delivery timeline';
        else if (transportationMode === 'Ocean')
            return 'This option is for palletized or equipment shipments that we have enough lead time to meet the delivery timeline -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Truck')
            return 'This option is generally for palletized shipments that are greater than 10,000kg with destinations of USA, Canada, or Mexico -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Express or LTL')
            return 'Express or LTL';
    }

   

}

angular
    .module('deliveryCreate.app')
    .controller('addShippingDetailsController', AddShippingDetailsController);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/addShippingDetails/controllers/addShippingDetailsController.ts
 **/